document.addEventListener('DOMContentLoaded', function() {
  var urlParams = new URLSearchParams(window.location.search);
  var selectedSize = urlParams.get('filter.v.option.taille');
  console.log('selectedSize:', selectedSize);
  if (!selectedSize) return;

  var cards = document.querySelectorAll('.card-wrapper.product-card-wrapper.underline-links-hover[data-variants]');
  for (var i = 0; i < cards.length; i++) {
    var card = cards[i];
    var rawVariants = card.getAttribute('data-variants') || '';
    console.log('Raw data-variants:', rawVariants);

    // Extraction du JSON complet : on cherche le premier "[" et le dernier "]"
    var start = rawVariants.indexOf('[');
    var end = rawVariants.lastIndexOf(']') + 1;
    var jsonStr = rawVariants.substring(start, end);
    console.log('Extracted JSON string:', jsonStr);

    var variants = [];
    try {
      variants = JSON.parse(jsonStr);
    } catch (e) {
      console.error('Erreur lors du parsing du JSON:', e);
      variants = [];
    }
    console.log('Parsed variants:', variants);

    var hasMatchingVariant = false;
    for (var j = 0; j < variants.length; j++) {
      var variant = variants[j];
      console.log('Test variant.option1:', variant.option1, 'available:', variant.available);
      // On vérifie que variant.option1 correspond à la taille sélectionnée et que la variante est disponible
      if (variant.option1 && variant.option1.trim() === selectedSize.trim() && variant.available === true) {
        hasMatchingVariant = true;
        break;
      }
    }
    console.log('hasMatchingVariant:', hasMatchingVariant);
    if (!hasMatchingVariant) {
      card.style.display = 'none';
      console.log('Hiding card due to no matching variant available.');
    }
  }
});
